export default __webpack_public_path__ + "static/media/guywithsneaks.535029c3.svg";